import {ValueObject} from '@s-ui/domain'

export class LocationValueObject extends ValueObject {
  /**
   * @constructor
   * @param {Object} param
   * @param {String} param.address
   * @param {String} param.city
   * @param {String} param.province
   * @param {String|Number} param.provinceId
   * @param {Array} param.provinceIds
   * @param {String} param.postalCode
   * @param {Object} param.coordinates
   * @param {String} param.coordinates.lat
   * @param {String} param.coordinates.lng
   * @param {String} param.mapsDirectionsUrl
   */

  getPostalCode() {
    return this._postalCode
  }
}
